module.exports = __webpack_public_path__ + "fonts/exo-regular-webfont.c0cdd664.eot";